import {appEnv} from '@/appEnv'
import {getTodaysDateSeed} from '@repo/shared/utils/getTodaysDateSeed'
import axios from 'axios'

type AverageDataType = {
  date: string
  time: number
  clicks: number
  player: string
  config: {
    store_winners_data: boolean
  }
}

export const getAverageDataForToday = async (): Promise<AverageDataType> => {
  const today = getTodaysDateSeed()
  return axios.get(`${appEnv.API_SINGLE_PLAYER_URL}/time/${today}`).then(res => res.data)
}
